import { SubmitTraitsGenerationContract } from 'src/js/modules/element-settings/helpers/stage-contracts';
import generateAdjustedEventTraits from 'src/js/modules/element-settings/helpers/generate-adjusted-event-traits';
import generateModifiedEventTraits from 'src/js/modules/element-settings/helpers/generate-modified-event-traits';
import { iframeFieldNames } from '../../ws-media/constants/field-names';
import iframeEmbeddingTypes from '../constants/iframe-embedding-types';

const getModifiedTraits = ({ prefix, iframeEmbeddingType, defaultIframeEmbeddingType }) => {
  if (iframeEmbeddingType === defaultIframeEmbeddingType) {
    return {};
  }

  return generateModifiedEventTraits(
    prefix,
    'embedVia',
    defaultIframeEmbeddingType,
    iframeEmbeddingType
  );
};

const getAdjustedTraits = ({
  prefix,
  iframeEmbeddingType,
  allowFullScreenValue,
  defaultAllowFullScreenValue,
}) => {
  if (
    iframeEmbeddingType !== iframeEmbeddingTypes.URL ||
    allowFullScreenValue === defaultAllowFullScreenValue
  ) {
    return {};
  }

  return generateAdjustedEventTraits(prefix, 'AllowFullScreen', allowFullScreenValue);
};

const createSubmitTraitsIframeHandler =
  ({ prefix }) =>
  (flowData, context) => {
    const fieldsValues = context.getFieldsValues();
    const defaultFieldsValues = context.getDefaultFieldsValues();

    const allowFullScreenValue = fieldsValues[iframeFieldNames.IFRAME_ALLOW_FULLSCREEN];
    const defaultAllowFullScreenValue =
      defaultFieldsValues[iframeFieldNames.IFRAME_ALLOW_FULLSCREEN];
    const iframeEmbeddingType = fieldsValues[iframeFieldNames.IFRAME_EMBEDDING_TYPE];
    const defaultIframeEmbeddingType = defaultFieldsValues[iframeFieldNames.IFRAME_EMBEDDING_TYPE];

    const adjusted = getAdjustedTraits({
      prefix,
      iframeEmbeddingType,
      allowFullScreenValue,
      defaultAllowFullScreenValue,
    });
    const modified = getModifiedTraits({ prefix, iframeEmbeddingType, defaultIframeEmbeddingType });

    return SubmitTraitsGenerationContract.create({ ...adjusted, ...modified });
  };

export default createSubmitTraitsIframeHandler;
